import React from 'react';

import { Link } from 'react-router-dom';
import Footer from '../../components/footer';
const TermsCondition = () => {

    return (
        <>
            <div className='App other-page-top my-credits-mobile'>
                <div className="AppContent BreakPointContainer">
                    <div>
                        <div className="StaticPageContent">
                            <div className="StaticPages p-t-25 p-b-25">
                                <div className="layout">

                                    <div className="flex xs12 sm12">
                                        <div className="m-t-25 return-ex">
                                            <h4>Terms & conditions</h4>
                                            <p className="m-b-6 p3">
                                                Welcome to the ORAT.IN website (“the Site,” “we,” “us,” or “our”). ORAT.IN provides this site as a service to its customers. Please read the following terms of service (“Terms”) as they govern your use of our site. By using this Site, you agree to follow and be bound by the following rule below. Additionally, ORAT.IN reserves the right to modify these terms at any time without prior notification. Site users must agree upon and abide by these changes accordingly. Please review this page periodically for changes. Any use of our site at any time constitutes full acceptance of our service Terms.
                                            </p>
                                            <h4 className="mt-2">DESCRIPTION OF SERVICE</h4>
                                            <p className="m-b-6 p3">
                                                ORAT.IN is a manufacturer and retailer of designer-quality goods offered at great values to the consumer. Our products mostly use high quality fabrics and are handcrafted.
                                            </p>
                                            <h4 className="mt-2">
                                                NOTICE
                                            </h4>
                                            <p className="m-b-6 p3">
                                                ORAT.IN may contact you or provide you with service-related and/ or promotional notices by means of postal mail, electronic mail, general site notifications and more using the contact information you have provided to us.
                                            </p>

                                            <h4 className="mt-2">
                                                PRICING POLICY
                                            </h4>
                                            <p className="m-b-6 p3">
                                                Prices are inclusive of Taxes, but not any custom charges that may occur for deliveries, or transaction fees that you may be charged by your bank for making a payment. We reserve the right to adjust any prices or shipping amounts at any time without notice.
                                            </p>
                                            <p className="m-b-6 p3">
                                                We have done our best to display our items as accurately as possible on the Site. Please be aware, variations in style, color, size, shape and look may occur. If you are not satisfied with your purchase, please review our Returns & Exchanges section for further assistance.
                                            </p>
                                            <p>&nbsp;</p>
                                        </div>
                                    </div>
                                </div>
                            </div></div></div>
                </div>
            </div>
            <Footer />
        </>
    )
}

export default TermsCondition